import { getCountry } from "./getCountry";

const country = getCountry();

export const VT_TO_I18N_LANGUAGE_MAP = {
	fr: "fr-CA",
	es: country === "CA" ? "es-CA" : "es",
	en: country === "CA" ? "en-CA" : "en",
};
